module.exports = __webpack_public_path__ + "img/weights.9f5365b1.svg";